class BuyProductController {
  voucherInfos;
  legalInfos;
  productRef;
  constructor ($rootScope, $scope, UserService, Localization, ProductService, ValidationRules, I18n, $window, $log, StoreTypes, DocumentsService, PurchaseInfos, $translate) {
    'ngInject'
    this.$scope = $scope
    this.$rootScope = $rootScope
    this.country = Localization.getCountry()
    this.type = Localization.getLocalizedAppConfig().type
    this.userService = UserService
    this.validationRules = ValidationRules
    this.documentsService = DocumentsService
    this.isProcessing = false
    this.init()
    this.codeCountry = ''
    this.productService = ProductService
    this.company = this.userService.getCurrentCompany()
    this.billingAddress = {}
    this.isCountryConcerned = false
    this.isEuropeanUnion = false
    this.countryConcerned()
    this.I18n = I18n
    this.countryUpper = Localization.getCountry().toUpperCase()
    this.$window = $window
    this.$log = $log
    this.StoreTypes = StoreTypes
    this.purchaseInfos = PurchaseInfos
    this.$scope.$watch('$ctrl.codeCountry', function () { $rootScope.$broadcast('buy-product:countryChanged', $scope.$ctrl.codeCountry) })
    this.documentsService.getUntreatedDocuments().then(result => {
      this.documentGtcId = -1
      this.documentWithdrawalId = -1
      if (result.size !== 0) {
        for (var doc of result) {
          if (doc.type === 'GTC') {
            this.documentGtcId = doc.id
          }
          if (doc.type === 'WITHDRAWAL') {
            this.documentWithdrawalId = doc.id
          }
        }
      }
    }).catch(() => {
      this.documentGtcId = -1
      this.documentWithdrawalId = -1
    })
  }

  init () {
    return this.userService.getCurrentUser()
    .then((user) => {
      this.user = user
      this.codeCountry = this.userService.getCountryOfResidence()
      this.billingAddress = {
        'firstName': user.firstName,
        'lastName': user.lastName,
        'zipCode': user.zipCode,
        'address': user.address,
        'city': user.city
      }
      this.isProcessing = false
    })
  }

  updatePrice (isPro = this.legalInfos !== undefined ? this.legalInfos.pro : undefined) {
    if (isPro === undefined) return
    this.$rootScope.$broadcast('buy-product:proToggled', isPro)
    this.isEuropeanUnionCountry(isPro)
  }

  isEuropeanUnionCountry (isPro) {
    if (isPro) {
      this.userService.isEuropeanUnionCountry(this.country)
      .then((res) => {
        this.error = null
        this.isEuropeanUnion = (res === 'true')
        this.$log.debug(this.isEuropeanUnion)
      }, (err) => {
        this.error = err
      })
    }
  }

  countryConcerned () {
    this.userService.countryConcernedByWithdrawalRights(this.country)
    .then((res) => {
      this.error = null
      this.isCountryConcerned = (res === 'true')
    }, (err) => {
      this.error = err
    })
  }

  isFreeVoucherProduct () {
    return (this.voucherInfos.isPurchaseUsingVoucher && (parseFloat(this.voucherInfos.amountReduction) === 0))
  }

  buyProduct (event) {
    if (this.$scope.buyProductForm.$valid && !this.purchaseInfos.beginLoadingB2BPrice) {
      const pspType = this.userService.getPspType()
      this.validForm = true
      if (!this.isFreeProduct) {
        this.isFreeProduct = this.isFreeVoucherProduct()
      }
      this.updateCountryOfResidence()
      .then(() => {
        if (pspType === 'SIPS' || this.isFreeProduct) {
          this.isPspSips = true
        } else {
          this.isPspWorldpay = true
        }
      })
      this.company.country = this.codeCountry
      this.billingAddress.country = this.codeCountry
      let companyCopy = JSON.parse(JSON.stringify(this.company))
      companyCopy.vatNumber = companyCopy.tvaNumber
      delete companyCopy.tvaNumber
      this.purchaseInfos = {
        isPro: this.legalInfos.pro,
        optIn: (this.legalInfos.offers) ? this.legalInfos.offers : false,
        withdrawalRights: this.legalInfos.retraction,
        buyer: {
          company: this.legalInfos.pro ? companyCopy : null,
          billingAddress: this.legalInfos.pro ? null : this.billingAddress
        },
        isFreeProduct: this.isFreeProduct
      }
      if (this.documentGtcId !== -1) {
        this.documentsService.sendDocumentConsent([this.documentGtcId])
      }
      if (this.documentWithdrawalId !== -1) {
        this.documentsService.sendDocumentConsent([this.documentWithdrawalId])
      }
    }
    event.preventDefault()
  }

  updateCountryOfResidence () {
    return this.userService.putCountryOfResidence(this.codeCountry)
    .then(() => {
      // MAJ session storage
      return this.userService.setCurrentUserCountryOfResidence(this.codeCountry)
    }, (err) => {
      this.error = err
    })
  }

  goBack () {
    this.$window.history.back()
  }

}

export default BuyProductController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/buy-product.controller.js